// extracted by mini-css-extract-plugin
export default {"chart__block":"TurnoverStatisticsChart_chart__block__hzJ6x"};